import React, { useEffect } from "react";
import "./BootstrapCarousel.css";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ConnectWallet from "../components/ConnectWallet";
import { useAccount, useSignMessage } from "wagmi";
import { setWalletAddress } from "../Redux/WallatSlice";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { addressToIdApi, registerUserApi } from "../utils/apiHandlers";

function Register() {
  const { isConnected, address } = useAccount();
  const dispatch = useDispatch();
  const { walletAddress, refAddress } = useSelector((state) => state.wallet);
  const [formData, setFormData] = useState({
    ref_id: "",
    address: "",
    referrer: "",
  });
  const { signMessageAsync } = useSignMessage(); // Use signMessageAsync instead of signMessage

  const handleSignMessage = async () => {
    try {
      // const msg =
      //   "register to blockagent" + formData?.address + formData?.referrer;
      // const signature = await signMessageAsync({
      //   message: msg,
      // });
      // console.log("Signed Message:", signature);
      register();
    } catch (error) {
      console.error("Signing failed:", error);
    }
  };

  const handleFormData = (value, field) => {
    const formStatesObj = { ...formData };
    formStatesObj[field] = value;
    setFormData({ ...formStatesObj });
  };

  async function register(signature, msg) {
    try {
      if (walletAddress === formData?.referrer) {
        toast.error("You can't refer yourself.");
        return;
      }

      // console.log(formData, signature, msg, "data");

      // Example: Send data to backend API
      const regresp = registerUserApi({
        ...formData,
        address: walletAddress,
      });
      const ress = await toast.promise(regresp, {
        loading: "Registration processing, please wait....",
        success: () => {},
        error: "Registration failed.",
      });

      if (ress?.message && ress?.status != 200) {
        toast.error(ress?.message);
      }
      if (ress?.status == 200) {
        toast.success(ress?.message);
      }
    } catch (e) {
      console.error(e, "Registration error");
      toast.error("An error occurred during registration.");
    }
  }

  useEffect(() => {
    // console.log(address,' address');
    if (address) {
      dispatch(setWalletAddress(address));
      handleFormData(address, "address");
    }
  }, [address, isConnected]);

  useEffect(() => {
    if (refAddress) {
      handleFormData(refAddress, "referrer");
    }
  }, [refAddress]);

  useEffect(() => {
    if (formData?.referrer) {
      addressToIdApi(formData?.referrer).then((res) => {
        if (res) {
          handleFormData(res?.id, "ref_id");
        }
      });
    }
  }, [formData?.referrer]);
  
  return (
    <>
      <div className="bodybg">
        <div
          class="page-wrapper"
          id="main-wrapper"
          data-layout="vertical"
          data-navbarbg="skin6"
          data-sidebartype="full"
          data-sidebar-position="fixed"
          data-header-position="fixed"
        >
          <div class="position-relative overflow-hidden  min-vh-100 d-flex align-items-center justify-content-center">
            <div class="d-flex align-items-center justify-content-center w-100">
              <div class="row justify-content-center w-100">
                <div class="col-md-8 col-lg-6 col-xxl-3">
                  <div class="card mb-0 cardbg">
                    <div class="card-body">
                      <a
                        href="#"
                        class="text-nowrap logo-img text-center d-block mb-5 w-100 "
                      >
                        <img
                          // src="assets/brandNameLogonobg.png"
                          src={require("../assets/logoWithName2.png")}
                          width="280"
                          alt=""
                          className=""
                        />
                      </a>

                      <div class="position-relative text-center my-4">
                        <h2 class="mb-3 fs-7 fw-bolder">
                          Create Your Account Now
                        </h2>
                      </div>
                      <div class="mb-3">
                        <p>
                          <ConnectWallet />
                        </p>
                      </div>

                      <div class="mb-3">
                        <label htmlFor="exampleInputEmail1" class="form-label">
                          Referral Address *
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="referral"
                          name="referral"
                          value={formData.referrer}
                          onChange={(e) =>
                            handleFormData(e?.target?.value, "referrer")
                          }
                          placeholder="Your Sponsor Address"
                        />
                      </div>
                      <div class="mb-3">
                        <label htmlFor="exampleInputEmail1" class="form-label">
                          Referral Id
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="referralId"
                          name="referralId"
                          value={formData?.ref_id || "Your Sponsor ID"}
                          readonly
                        />
                      </div>

                      <button
                        class="btn btn-primary w-100 py-8 mb-4 rounded-2 registra mybtncolor"
                        onClick={handleSignMessage}
                      >
                        Submit
                      </button>
                      <div class="d-flex align-items-center">
                        <p class="fs-4 mb-0 text-dark">
                          Already have an Account?
                        </p>
                        <Link class="text-primary fw-medium ms-2" to="/Login">
                          Login
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
